import React, { createContext, FC, ReactNode, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { getUserDataWithUsername, IUserProps } from '../common/data/userDummyData';

export interface IAuthContextProps {
	user: string;
	setUser?(...args: unknown[]): unknown;
	userData: Partial<IUserProps>;
}
const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps);

interface IAuthContextProviderProps {
	children: ReactNode;
}
export const AuthContextProvider: FC<IAuthContextProviderProps> = ({ children }) => {
	const loacal = localStorage.getItem('Filez_authUsername') 

	const [user, setUser] = useState<string>(loacal|| '');
	const [userData, setUserData] = useState<Partial<IUserProps>>({});
 

	useEffect(() => {
		// localStorage.setItem('Filez_authUsername', user);
		setUser(loacal as any)
	}, [loacal]);

	useEffect(() => {
		if (user !== '') {
			setUserData(getUserDataWithUsername(user));
		} else {
			setUserData({});
		}
	}, [user]);

	const value = useMemo(
		() => ({
			user,
			setUser,
			userData,
		}),
		[user, userData],
	);
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
// @ts-ignore
// @ts-ignore
AuthContextProvider.propTypes = {
	// @ts-ignore
	children: (PropTypes.node as any).isRequired,
};

export default AuthContext;
